<template>
  <div class="Mine" :style="{ 'width': _isMobile() ? '100%' : '1200px' }">
    <div class="mainContent" :style="{ borderRadius: _isMobile() ? '28px 28px 0 0' : 'none' }">
      <div class="header">
        <template v-if="_isMobile()">
          <a-row type="flex" justify="start" align="middle" style="width: 100%;">
            <a-col flex="81px">
              <a-avatar :size="81" icon="user" :src="avatarUrl" style="margin-top: -20px;" />
            </a-col>
            <a-col flex="auto" :offset="1">
              <template v-if="$store.state.user.info">
                <p class="name">{{ $store.state.user.info.realname }}</p>
                <p class="calssName">{{ departName.schoolName }}</p>
              </template>
              <template v-else>
                <p class="name" @click="toPageFn('/login')"> 未登录</p>
              </template>
            </a-col>
          </a-row>
        </template>
        <img src="../assets/image/JXW.png" class="jxwLogo" alt="">
      </div>
      <!-- <div class="classInfoBox">
        <a-row type="flex" justify="center" align="middle" style="height: 100%;">
          <a-col :span="10" style="font-size: 17px;">
            我的班级 <i class="iconfont">&#xe661;</i>
          </a-col>
          <a-col :span="7">
            查看班级情况
          </a-col>
          <a-col :span="7">
            <div class="seeButton">点击查看</div>
          </a-col>
        </a-row>
      </div> -->
      <a-row type="flex" justify="space-between" style="width: 90%;margin: 15px auto;">
        <a-col v-for="item, index in menuList" :key="index" :xs="11" :sm="11" :md="7" :lg="5" :xl="5">
          <div class="menuList" @click="toPageFn(item.url,item.menuName)" :style="{ backgroundImage: 'url(' + item.imgUrl + ')' }">
            <div class="left">
              <p class="menuName">{{ item.menuName }}</p>
              <p class="viceMenuName">立即查看></p>
            </div>
          </div>
        </a-col>
      </a-row>
      <a-divider style="margin: 12px 0;" />
      <div class="pageList" @click="toPageFn('/course/ExamHistory','考试记录')">
        <div><i class="iconfont" style="color: #FF8A2B;">&#xe6b8;</i><span style="font-weight: bold;">考试记录</span></div>
        <p><i class="iconfont">&#xe7a7;</i></p>
      </div>
      <a-divider style="margin: 12px 0;" />
      <div class="pageList" @click="toPageFn('/course/integralList','分数明细')">
        <div><i class="iconfont" style="color: #FF8A2B;">&#xe61a;</i><span style="font-weight: bold;">我的分数</span><span style="font-size: 14px;font-weight: bold;padding-left: 10px;">({{$store.state.user.info.integral }})</span></div>
        <p><i class="iconfont">&#xe7a7;</i></p>
      </div>
      <a-divider style="margin: 12px 0;" />
      <a-row style="margin-top: 50px;" type="flex" justify="center" v-if="_isMobile()">
        <a-col :span="18">
          <div class="outButton" @click="handleLogout" v-if="$store.state.user.info">退出登录</div>
        </a-col>
      </a-row>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import Banner from '../components/Banner.vue';
import { mixinDevice } from "@/utils/mixin.js";
import { SYSTEM_INFO } from "@/store/mutation-types";
import { mapActions } from "vuex";
import {getAction} from '@/api/manage'
export default {
  name: 'Mine',
  components: { Banner },
  mixins: [mixinDevice],
  computed: {
    avatarUrl() {
      if (this.$store.state.user.avatar) {
        return this.$store.state.user.avatar
      } else if (this.$store.state.user.info && this.$store.state.user.info.avatar) {
        return this.$store.state.user.info.avatar
      } else {
        return "/img/avatar.png"
      }
    },
    departName(){
      return Vue.ls.get(SYSTEM_INFO)
    }
  },
  data() {
    return {
      menuList: [
        // {
        //   menuName: '我的收藏',
        //   url: '/examination/index',
        //   imgUrl: require('../assets/image/WD_SC.png'),
        // }, {
        //   menuName: '我的作业',
        //   url: '',
        //   imgUrl: require('../assets/image/WD_DT.png'),
        // }, 
        {
          menuName: '我的错题',
          url: '/course/ErrorWorkbook',
          imgUrl: require('../assets/image/WD_ZY.png'),
        }, {
          menuName: '心理健康',
          url: '/course/psychology',
          imgUrl: require('../assets/image/WD_JK.png'),
        }
      ],
      mySocre:0,
    }
  },
  created() { 
  },
  mounted() {
    console.log(this.$store.state  ,' vuex数据')
   },
  methods: {
    ...mapActions(["Logout"]),
    toPageFn(url,name) {
      this.$router.push({ path: url,query:{name:name} });
    },
    handleLogout() {
      const that = this;
      this.$confirm({
        title: "提示",
        content: "真的要注销登录吗 ?",
        onOk() {
          return that
            .Logout({})
            .then(() => {
              window.location.reload()
            })
            .catch((err) => {
              that.$message.error({
                title: "错误",
                description: err.message,
              });
            });
        },
        onCancel() { },
      });
    },
  }
}
</script>
<style lang='scss' scoped>
.Mine {
  width: 100%;
  padding-bottom: 120px;
  margin: -28px auto;

  .mainContent {
    width: 100%;
    // border-radius: 28px 28px 0 0;
    background: #fff;

    .header {
      width: 100%;
      height: 60px;
      padding: 0 16px;
      position: relative;

      .name {
        font-size: 16px;
        font-weight: bold;
        color: #000000;
        line-height: 30px;
      }

      .calssName {
        font-size: 10px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #303030;
        line-height: 15px;
        opacity: 0.8;
      }

      .jxwLogo {
        width: 67px;
        height: 70px;
        position: absolute;
        top: -31px;
        right: 13px;
        z-index: 9;
      }
    }
  }

  .classInfoBox {
    width: 90%;
    margin: 18px auto;
    padding: 0 16px;
    height: 51px;
    background: #2F2C33;
    border-radius: 14px;
    color: #fff;

    .seeButton {
      width: 75px;
      height: 26px;
      background: linear-gradient(84deg, #FFDFC1 0%, #FFB16F 100%);
      border-radius: 13px;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #85522D;
      text-align: center;
      line-height: 26px;
      float: right;
    }
  }

  .pageList {
    width: 100%;
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    font-family: SourceHanSansCN;
    color: #000000;
    cursor: pointer;
    border-radius: 5px;
  }
  // .pageList:hover{
  //   background: #F75250;
  //       color: #fff;
  // }

  .menuList {
    width: 100%;
    height: 86px;
    padding: 0 14px;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 22px;
    background-size: 100% 100%;

    .menuName {
      font-size: 19px;
      color: #fff;
      font-weight: bold;
    }

    .viceMenuName {
      font-size: 12px;
      color: #fff;
      opacity: 0.5;
    }
  }

  .outButton {
    width: 100%;
    height: 40px;
    border-radius: 5px;
    background: #F75250;
    font-size: 18px;
    text-align: center;
    line-height: 40px;
    color: #fff;
  }
}
</style>
